import { useContext } from 'react'
import GlobalContext from '../context/GlobalContext'
import { InputProps } from '@fluentui/react-input'
import { CheckboxProps } from '@fluentui/react-checkbox'
import { BaseComboboxProps } from '../components/Combobox/BaseCombobox'
import { LocalDatePickerProps } from '../components/DatePicker/LocalDatePicker'
import { MoneyInputProps } from '../components/Input/MoneyInput'
import { TextareaProps } from '@fluentui/react-components'
import { KeyValue } from '../components/Form/Attributes/AttributesList'

export enum AttributeType {
    Boolean = 'BOOLEAN',
    KeyValueList = 'KEYVALUE_LIST',
    LocalDate = 'LOCALDATE',
    Money = 'MONEY',
    Number = 'NUMBER',
    String = 'STRING',
    Text = 'TEXT',
}

export enum EntityAttributeType {
    File = 'FILE',
    Invoice = 'INVOICE',
    Party = 'PARTY',
}

export enum AttributeContextType {
    File = 'FILE',
    NaturalPerson = 'NATURAL_PERSON',
    LegalPerson = 'LEGAL_PERSON',
    Invoice = 'INVOICE',
}

export enum AttributeViewType {
    Input = 'INPUT',
    View = 'VIEW',
    Filter = 'FILTER',
}

export type AttributeDefinitionProperties = Partial<InputProps> &
    Partial<CheckboxProps> &
    Partial<BaseComboboxProps<KeyValue>> &
    Partial<LocalDatePickerProps> &
    Partial<MoneyInputProps> &
    Partial<TextareaProps> & {
        //generic
        initialValue?: string
        //datepicker
        useToday?: boolean
    }

export type AttributeDependencyDto = {
    id: string
    value?: any[]
    evaluation?: string
}

export type AttributeDefinitionDto = {
    id: string
    name: string
    dataType: AttributeType
    context: AttributeContextType[]
    position?: number
    enabled: boolean
    description?: string
    properties?: AttributeDefinitionProperties
    filter: boolean
    dependencies?: AttributeDependencyDto[]
}

export type AttributeDto = {
    id?: string
    definitionId: string
    entityId?: string
    entityType: EntityAttributeType
    value: any
}

export type AttributeEntityDto = {
    attributes?: AttributeDto[]
    currency?: string
}

export function useAttributes(): AttributeDefinitionDto[] {
    const { attributeDefinitions } = useContext(GlobalContext)

    return attributeDefinitions
}
